import React from 'react';
import Navigation from '../components/Navigation/Navigation';
import Header from '../components/Header/Header';
import HerStory from '../components/HerStory/HerStory';
import HisStory from '../components/HisStory/HisStory';
import ImageCarousel from '../components/ImageCarousel/ImageCarousel';
import Details from '../components/Details/Details';
import RSVP from '../components/RSVP/RSVP';
import EvidenceNotebook from '../components/EvidenceNotebook/EvidenceNotebook';

const HomePage = () => {
  // Carousel images from public/carousel folder
  // Using edited versions where available
  const carouselImages = [
    '/carousel/IMG_3288_edited.jpg',
    '/carousel/IMG_2466_edited.jpg',
    '/carousel/IMG_3945.jpeg',
    '/carousel/3c5376a0-256e-4952-a262-59da89a9fc89.jpg',
    '/carousel/IMG_0970_edited.jpg',
    '/carousel/IMG_0799.jpeg',
    '/carousel/IMG_0482.jpeg',
    '/carousel/IMG_4617.jpeg',
    '/carousel/IMG_1559.jpeg',
    '/carousel/IMG_2151.jpeg',
  ];

  return (
    <>
      <Navigation />
      <div className="main-content">
        <section id="home" className="home-section">
          <Header />
        </section>
        <HerStory />
        <HisStory />
        <ImageCarousel images={carouselImages} />
        <Details />
        <RSVP />
        <EvidenceNotebook />
      </div>
    </>
  );
};

export default HomePage;
